import CommonMethodObj from "../constants/LobConstants";
import moment from "moment";
export function getMasterDataObj(masterDataKey, dataListObj) {
  let masterDataKeyList = CommonMethodObj.MASTER_DATA_KEY;
  let masterData = [];
  dataListObj.map((dataObj) => {
    if (Object.keys(dataObj)[0] == masterDataKeyList[masterDataKey]) {
      masterData = dataObj[Object.keys(dataObj)[0]];
    }
  });
  return masterData;
}

export function compareDates(selectedMaxDateTime, selectedMinDateTime) {
  if(!selectedMinDateTime){
    return true;
  }
  let maxDateTime = new Date(
    moment(selectedMaxDateTime).format("YYYY-MM-DD HH:mm")
  );
  let minDateTime = new Date(
    moment(selectedMinDateTime).format("YYYY-MM-DD HH:mm")
  );
  let minTimeSeconds = minDateTime.getTime() / 1000;
  let maxTimeSeconds = maxDateTime.getTime() / 1000;
  if (minTimeSeconds <= maxTimeSeconds) {
    return true;
  } else {
    return false;
  }
}

export function getLoggedInUserName() {
  return "TMILL";
}
const changeDatetimeFormat = (datetimeObj) => {
  return datetimeObj ? moment.utc(datetimeObj).local().format() : null;
};
export function getLoggedInSessionEmail() {
  return sessionStorage.getItem("user_email");
}
export default {
  getLoggedInUserName,
  changeDatetimeFormat,
  getLoggedInSessionEmail
};
